<template>
  <div class="map-layout">

    <!-- Левая часть — карта -->
    <div class="map-pane">
      <MapPane :properties="properties" />
    </div>

    <!-- Правая часть — фильтр + список -->
    <div class="list-pane">
      <MiniFilterBar @update="onFilterUpdate" />
      <PropertyCards :properties="properties" />
    </div>

  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { storeToRefs } from 'pinia'
import { useLanguageStore } from '@/stores/languageStore'
import { useFilterStore } from '@/stores/filterStore'

import MiniFilterBar from '../../components/MiniFilterBar.vue'
import PropertyCards from '../../pages/property_list/PropertyCards.vue'
import MapPane from './MapPane.vue'

/* 🌍 язык */
const languageStore = useLanguageStore()
const { locale } = storeToRefs(languageStore)

/* 🧭 фильтры */
const filterStore = useFilterStore()

/* 📦 единый источник данных */
const properties = ref([])

/* 🔄 загрузка объектов */
async function fetchProperties(filters = {}) {
  const xLocale = (locale.value || 'ru').split('-')[0]

  const params = new URLSearchParams({
    ...filterStore.$state,
    ...filters,
    per_page: 200,
    locale: xLocale,
    _ts: Date.now()
  })

  const res = await fetch(`/api/v1/properties?${params}`)
  const data = await res.json()

  properties.value = data.properties || []
}

/* 🎯 событие от MiniFilterBar */
function onFilterUpdate(filters) {
  filterStore.setFilters(filters)
  fetchProperties(filters)
}

/* 🚀 старт */
onMounted(() => {
  fetchProperties()
})

</script>

<style scoped>
.map-layout {
  display: grid;
  grid-template-columns: 50% 50%;
  height: calc(100vh - 60px);
}

.map-pane {
  height: 100%;
}

.list-pane {
  overflow-y: auto;
  padding: 12px;
  background: #f8f9fa;
}

</style>
